import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

async function getVoicePreviewUrl(auth: Authentication | null, voiceId: string): Promise<string> {
  try {
    if (!auth) {
      throw new GetVoicePreviewUrlFailure(
        'Vous devez être connecté pour effectuer cette action.',
        'unauthorized'
      );
    }

    const json = await HttpClient.get(`/elevenlabs/voices/${voiceId}/preview`, auth.token);

    return json.data.preview_url;
  } catch (e) {
    if (e instanceof GetVoicePreviewUrlFailure) throw e;
    console.log('error: ', e);
    throw new GetVoicePreviewUrlFailure();
  }
}

export class GetVoicePreviewUrlFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getVoicePreviewUrl;
